import {
  Button,
  Grid,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useFetchAllAppliedJob from "../../../api/effects/queries/Job/useFetchAllAppliedJob";
import { AppliedKandidatResponse } from "../../../models/Kandidat";
import { convertDate, convertDateTime } from "../../../utils/dateConvert";

const SquareGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: "#FFF",
  height: "auto",
  width: "90%",
  boxShadow: "1px 1px 10px #888888",
  borderRadius: "10px",
  padding: "1%",
  maxHeight: "44vh",
  [theme.breakpoints.down("md")]: {
    width: "60%",
  },
  [theme.breakpoints.down("sm")]: {
    width: "80%",
    padding: "10px",
  },
  margin: "1%",
}));

const ClearLink = styled(Link)({
  textDecoration: "none",
  textTransform: "none",
});

export default function AppliedJobTable() {
  const { data: AllAppliedJobData } = useFetchAllAppliedJob();

  const [tableData, setTableData] = useState<AppliedKandidatResponse[]>([]);

  useEffect(() => {
    if (AllAppliedJobData !== undefined) {
      setTableData(AllAppliedJobData);
    }
  }, [AllAppliedJobData]);

  if (tableData.length < 1) {
    return (
      <Grid container justifyContent="center">
        <Grid
          container
          justifyContent="center"
          item
          xs={12}
          sx={{ paddingBottom: "10px" }}
        >
          <Typography variant="h6" color="black">
            Start Your Career Now
          </Typography>
        </Grid>
        <ClearLink to="/">
          <Button variant="contained">Search Job</Button>
        </ClearLink>
      </Grid>
    );
  }

  return (
    <Grid container justifyContent="center">
      <SquareGrid container>
        <TableContainer component={Paper} sx={{ maxHeight: "100%" }}>
          <Table aria-label="simple table" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Job</TableCell>
                <TableCell>Tanggal Apply</TableCell>
                <TableCell>Tempat Interview</TableCell>
                <TableCell>Alamat Interview</TableCell>
                <TableCell>Tanggal Interview</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData.map((row, key) => (
                <TableRow
                  key={key}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell>{row.JOB}</TableCell>
                  <TableCell>{convertDate(row.TANGGAL_APPLY)}</TableCell>
                  <TableCell>
                    {row.TEMPAT_INTERVIEW
                      ? row.TEMPAT_INTERVIEW
                      : "Belum Ditentukan"}
                  </TableCell>
                  <TableCell>
                    {row.ALAMAT_INTERVIEW ? (
                      row.TEMPAT_INTERVIEW === "Offline" ? (
                        row.ALAMAT_INTERVIEW
                      ) : (
                        <a
                          style={{ color: "#00ACED" }}
                          href={row.ALAMAT_INTERVIEW}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Link Interview
                        </a>
                      )
                    ) : (
                      "Belum Ditentukan"
                    )}
                  </TableCell>
                  <TableCell>
                    {row.TANGGAL_INTERVIEW
                      ? `${convertDateTime({
                          date: row.TANGGAL_INTERVIEW,
                        })} WIB`
                      : "Belum Dijadwalkan"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </SquareGrid>
    </Grid>
  );
}
